import { Box, Button, Divider, Text, HStack } from '@chakra-ui/react';
import React, { useContext, useEffect, useCallback } from 'react';
import { CartContext } from '../../../context/cart';
import useCartStore from '../../../store/cartStore';

export const CheckoutCard = () => {
  const { setActiveStep, cartData, activeStep, orderDetail, isPaymentMethodConfirmed, setTriggerOrderPlacement } = useContext(CartContext);
  const { totalOrderPrice, setTotalOrderPrice } = useCartStore();

  const updateFinalPrice = useCallback(() => {
    if (!cartData) return;
    let totalPrice = 0;
    cartData.forEach(cartItem => {
      totalPrice =
        totalPrice +
        (cartItem?.patients?.length
          ? parseInt(cartItem.price) * parseInt(cartItem.patients.length)
          : 0);
    });
    setTotalOrderPrice(totalPrice);
  }, [cartData, setTotalOrderPrice]);

  const validateStep = () => {
    if (activeStep === 2) {
      if (!orderDetail?.mainAddress) {
        alert("Please enter your House No. / Building Name (Main Address).");
        return false;
      }
      if (!orderDetail?.address?.addressType) {
        alert("Please select an Address Category (Home, Work, or Others).");
        return false;
      }
      if (!orderDetail?.email || !orderDetail?.email.includes('@')) {
        alert("Please enter a valid email address.");
        return false;
      }
      if (!orderDetail?.phone || orderDetail?.phone.length < 10) {
        alert("Please enter a valid 10-digit phone number.");
        return false;
      }
    }

    if (activeStep === 3) {
      if (!orderDetail?.appointmentDate) {
        alert("Please select a collection date from the calendar.");
        return false;
      }
      if (!orderDetail?.appointmentTime) {
        alert("Please select a time slot for collection.");
        return false;
      }
    }

    return true;
  };

  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

   const handleNext = () => {
    if (activeStep === 5) {
      setTriggerOrderPlacement(true);
      return;
    }
    if (validateStep()) {
      setActiveStep(activeStep + 1);
    }
  };

  const handleBack = () => {
    if (activeStep > 1) {
      setActiveStep(activeStep - 1);
    }
  };

  const getButtonText = () => {
    switch (activeStep) {
       case 1: return 'Proceed to Checkout';
      case 2: return 'Select Collection Address';
      case 3: return 'Select Date & Time';
      case 4: return 'Complete Order';
      case 5: return 'Confirm order';
      default: return 'Continue';
    }
  };

  useEffect(() => {
    updateFinalPrice();
  }, [updateFinalPrice]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        flex: 3,
        width: '100%',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDir: 'column',
          borderRadius: '20px',
          border: '1px solid rgba(0, 0, 0, 0.2)',
          gap: '15px',
          p: '20px',
        }}
      >
        <Text
          sx={{
            color: 'black',
            fontWeight: 600,
          }}
        >
          {cartData?.length} Lab Tests
        </Text>
        <Divider />
        {cartData?.map((cartItem, idx) => {
          const names = cartItem?.patients?.map(person => person?.name);
          const result = names?.join(', ').replace(/,([^,]*)$/, ' &$1');
          return (
            <Box
              key={idx}
              sx={{
                color: 'black',
                display: 'flex',
                flexDir: 'column',
                gap: '20px',
                alignItems: 'flex-start',
              }}
            >
              <Text
                sx={{
                  color: 'black',
                  fontWeight: 600,
                }}
              >
                {result || "No patients assigned"}
              </Text>
              <Box
                sx={{
                  border: '1px solid rgba(0, 0, 0, 0.2)',
                  borderRadius: '20px',
                  display: 'flex',
                  py: '20px',
                  justifyContent: 'space-between',
                  px: '20px',
                  width: '100%',
                }}
              >
                <Text
                  sx={{
                    color: 'black',
                    fontWeight: 600,
                    width: '60%',
                  }}
                >
                  {cartItem?.name}
                </Text>
                <Text
                  sx={{
                    color: 'black',
                    fontWeight: 600,
                  }}
                >
                  {cartItem?.patients
                    ? parseInt(cartItem?.price) *
                      parseInt(cartItem?.patients?.length)
                    : 0}
                  /-
                </Text>
              </Box>
            </Box>
          );
        })}
        <Divider />
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Text
            sx={{
              color: 'black',
              fontWeight: 600,
            }}
          >
            Total
          </Text>
          <Text
            sx={{
              color: 'black',
              fontWeight: 600,
            }}
          >
            {totalOrderPrice} /-
          </Text>
        </Box>
      </Box>
      <HStack width="full" spacing={4}>
        {activeStep > 1 && activeStep < 5 && (
          <Button
            variant="outline"
            color="teal"
            borderColor="teal"
            py="25px"
            height="auto"
            borderRadius="15px"
            flex={1}
            onClick={handleBack}
            _hover={{
              bg: 'teal.50',
            }}
          >
            Back
          </Button>
        )}
        <Button
          flex={activeStep > 1 && activeStep < 5 ? 2 : 1}
          sx={{
            backgroundColor: 'teal',
            color: 'white',
            py: '25px',
            height: 'auto',
            borderRadius: '15px',
            _hover: {
              backgroundColor: '#0a636e',
            },
          }}
          isDisabled={
            (activeStep === 2 && (
              !orderDetail?.mainAddress || 
              !orderDetail?.address?.addressType || 
              !isValidEmail(orderDetail?.email) || 
              !orderDetail?.phone ||
              orderDetail?.phone.length < 10
            )) ||
            (activeStep === 3 && (
              !orderDetail?.appointmentDate || 
              !orderDetail?.appointmentTime
            )) ||
            (activeStep === 5 && !isPaymentMethodConfirmed)
          }
          onClick={handleNext}
        >
          {getButtonText()}
        </Button>
      </HStack>
    </Box>
  );
};
